import { useRef, useState } from "react";

export default function BeforeAfter({ before, after, label = "Drag to reveal" }) {
  const [pos, setPos] = useState(50);
  const ref = useRef(null);

  const move = (clientX) => {
    const r = ref.current.getBoundingClientRect();
    const p = Math.min(100, Math.max(0, ((clientX - r.left) / r.width) * 100));
    setPos(p);
  };

  return (
    <div
      ref={ref}
      className="relative w-full overflow-hidden rounded-lg select-none"
      style={{ aspectRatio: '16/10', background: '#000' }}
      onMouseMove={(e) => e.buttons === 1 && move(e.clientX)}
      onTouchMove={(e) => e.touches[0] && move(e.touches[0].clientX)}
      data-testid="before-after-slider"
    >
      <img src={after} alt="after" className="absolute inset-0 w-full h-full object-cover" />
      <div className="absolute inset-0 overflow-hidden" style={{ width: `${pos}%` }}>
        <img src={before} alt="before" className="absolute inset-0 w-full h-full object-cover" style={{ width: `${100 / (pos / 100 || 1)}%`, maxWidth: 'none' }} />
      </div>
      <div className="absolute top-3 left-3 badge">Before</div>
      <div className="absolute top-3 right-3 badge badge-rust">After</div>
      <div className="absolute top-0 bottom-0" style={{ left: `${pos}%`, transform: 'translateX(-50%)' }}>
        <div className="w-0.5 h-full" style={{ background: 'var(--accent)' }} />
        <div
          className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-10 h-10 rounded-full flex items-center justify-center cursor-ew-resize"
          style={{ background: 'var(--accent)', boxShadow: '0 0 0 4px rgba(11,19,43,0.5)' }}
        >
          <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="#0B132B" strokeWidth="2.5">
            <polyline points="15 18 9 12 15 6" /><polyline points="9 18 15 12 9 6" transform="translate(0)"/>
          </svg>
        </div>
      </div>
      <input
        type="range"
        min="0"
        max="100"
        value={pos}
        onChange={(e) => setPos(Number(e.target.value))}
        className="absolute inset-0 w-full h-full opacity-0 cursor-ew-resize"
        aria-label={label}
      />
    </div>
  );
}
